import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const splashclassImprovementModule = namespace('splashclassImprovements');
let CharactersSplashclassImprovements = class CharactersSplashclassImprovements extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Splashclass Improvements';
    }
    created() {
        this.fetchSplashclassImprovements();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.splashclassImprovements)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(splashclassImprovement => ({
            ...splashclassImprovement,
            id: splashclassImprovement.name,
            isExpandable: splashclassImprovement.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    splashclassImprovementModule.State
], CharactersSplashclassImprovements.prototype, "splashclassImprovements", void 0);
__decorate([
    splashclassImprovementModule.Action
], CharactersSplashclassImprovements.prototype, "fetchSplashclassImprovements", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersSplashclassImprovements.prototype, "isInHandbook", void 0);
CharactersSplashclassImprovements = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersSplashclassImprovements);
export default CharactersSplashclassImprovements;
